import * as React from "react";
const SvgExpander = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 15 15"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M.006 14.984V10.16h1.502v3.325h3.329v1.5H.006Zm0-9.175V.984h4.83v1.5H1.509V5.81H.006Zm9.186 9.175v-1.5h3.329V10.16h1.502v4.825H9.192Zm3.329-9.175V2.484H9.192v-1.5h4.83V5.81h-1.501Z"
      fill={props?.fill || "#091E42"}
    />
  </svg>
);
export default SvgExpander;
